export default __webpack_public_path__ + "media/for-offline-counselling.ea6835e1.png";